import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CheckboxSimple from "./CheckboxSimple";
import Gender from "./Gender";
import Price from "./Price";
import CheckboxLabel from "./CheckboxLabel";
import { getPropByLanguage } from "../../../../../utils/Language";
import { useApp } from "../../../../../contexts";

function FilterPrime(props) {
  const { language, T: t } = useApp();
  const propLang = getPropByLanguage(language);

  const { setFilterData, filterData, breedOptions } = props;

  const [breedOptionLocals, $breedOptionLocals] = useState([]);

  const [isMintNftOptions, $isMintNftOptions] = useState([
    { value: "0", title: "All" },
    { value: "2", title: "Minted" },
    { value: "1", title: "Unmint" },
  ]);

  const [skus, $skus] = useState(filterData?.skus || []);
  const [isMintNft, $isMintNft] = useState(filterData?.isMintNft);

  useEffect(() => {
    $skus([]);
    $isMintNft([]);
  }, []);
  useEffect(() => {
    if (breedOptions?.length > 0) {
      const translatedBreeds = breedOptions?.map((breed) => {
        return {
          title: breed.description,
          value: breed.sku,
        };
      });
      $breedOptionLocals([{ value: "", title: "All" }, ...translatedBreeds]);
    }
  }, [breedOptions, propLang]);

  const onChangeBreed = (val) => {
    const data = val.map((v) => v);
    $skus(data);
    setFilterData({
      skus: data,
      isMintNft,
    });
  };
  const onChangeMint = (val) => {
    $isMintNft(val);
    setFilterData({
      skus,
      isMintNft: val,
    });
  };
  return (
    <div>
      <CheckboxSimple
        title={t("ART PRIME")}
        name={"skus"}
        options={breedOptionLocals}
        value={skus}
        t={t}
        onChange={(val) => onChangeBreed(val)}
      />
      <Gender
        title={t("Mint Status")}
        name={"isMintNft"}
        options={isMintNftOptions}
        t={t}
        value={isMintNft}
        onChange={(val) => onChangeMint(val)}
      />
    </div>
  );
}

FilterPrime.propTypes = {
  setFilterData: PropTypes.func,
  filterData: PropTypes.object,
  showing: PropTypes.number,
};

export default FilterPrime;
